import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function Cancel() {
  const { t } = useTranslation();

  return (
    <>
      <Navbar />
      <section className="min-vh-100 d-flex align-items-center py-5" style={{ background: 'linear-gradient(135deg, #fef2f2, #fff7ed)' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-8 text-center">
              <div className="card border-0 shadow-lg rounded-4 p-5">
                <div className="mb-4" style={{ fontSize: '5rem' }}>😢</div>
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4 mx-auto"
                  style={{ width: 72, height: 72, background: 'linear-gradient(135deg, #f87171, #ef4444)', color: '#fff', fontSize: '2rem' }}
                >
                  <i className="bi bi-x-lg" />
                </div>
                <h2 className="fw-bold mb-3 text-danger">{t('cancel.title')}</h2>
                <p className="text-muted mb-5" style={{ lineHeight: 1.8 }}>{t('cancel.message')}</p>
                <Link to="/#donate" className="btn btn-donate px-5 py-3 fs-5">
                  <i className="bi bi-arrow-left me-2" />
                  {t('cancel.retryBtn')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
